import { Group, Select, Stack } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMembers } from '@/api/workspace';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { PageHeader } from '@/components/PageHeader';
import { EntryList } from './EntryList';
import { PlannedToday } from './PlannedToday';
import { TimerBar } from './TimerBar';

/** Time Tracker (TT): Timer-Leiste und Eintragsliste, optional für Teammitglieder. */
export function TrackerPage() {
  const { t } = useTranslation();
  const ctx = useCurrentWorkspace();
  const [userId, setUserId] = useState<string | undefined>(undefined);
  const canTrackForOthers = ctx.isManager && ctx.hasFeature('TIME_FOR_OTHERS');

  return (
    <Stack gap={0} maw={1200}>
      <PageHeader title={t('nav.items.tracker')}>
        {canTrackForOthers && <TeammateSelect value={userId} onChange={setUserId} />}
      </PageHeader>
      <TimerBar key={userId ?? 'me'} userId={userId} />
      {!userId && <PlannedToday />}
      <EntryList userId={userId} />
    </Stack>
  );
}

/** Teammitglieder-Auswahl (UI-06). */
export function TeammateSelect({ value, onChange }: { value?: string; onChange: (userId?: string) => void }) {
  const { t } = useTranslation();
  const ctx = useCurrentWorkspace();
  const { data: members = [] } = useMembers(ctx.workspaceId);
  const options = members
    .filter((m) => m.status === 'ACTIVE' && m.userId && (ctx.isAdmin || ctx.workspace.me.managedUserIds.includes(m.userId) || m.userId === ctx.user.id))
    .map((m) => ({ value: m.userId!, label: m.userId === ctx.user.id ? `${m.name} (${t('common.me')})` : m.name }));
  return (
    <Group>
      <Select
        data={options}
        value={value ?? ctx.user.id}
        onChange={(v) => onChange(v && v !== ctx.user.id ? v : undefined)}
        searchable
        w={220}
        aria-label={t('common.teammates')}
        allowDeselect={false}
      />
    </Group>
  );
}
